// API_ENDPOINTS: Single source of truth for endpoint keys, paths, and methods
// ** Update the handlerMap in serverless/main/lib/routes.ts to match the key **
export const API_ENDPOINTS = {
  axiomEmail: {
    basePath: 'axiom-email',
    pathParameter: 'quoteId',
    invoke: (quoteId: string) => `axiom-email/${quoteId}` as ApiEndpointInvoke,
    method: 'POST',
  },
  axiomQuote: {
    basePath: 'axiom-quote',
    pathParameter: undefined,
    invoke: () => 'axiom-quote' as ApiEndpointInvoke,
    method: 'POST',
  },
  developerTools: {
    basePath: 'developer-tools',
    pathParameter: undefined,
    invoke: () => 'developer-tools' as ApiEndpointInvoke,
    method: 'POST',
  },
  pcSubmissionNumber: {
    basePath: 'pc-submission-number',
    pathParameter: 'submissionNumber',
    invoke: (submissionNumber: string) => `pc-submission-number/${submissionNumber}` as ApiEndpointInvoke,
    method: 'GET',
  },
  pcPolicyNumber: {
    basePath: 'pc-policy-number',
    pathParameter: 'policyNumber',
    invoke: (policyNumber: string) => `pc-policy-number/${policyNumber}` as ApiEndpointInvoke,
    method: 'GET',
  },
} as const;

export type ApiEndpointBasePath = (typeof API_ENDPOINTS)[keyof typeof API_ENDPOINTS]['basePath'];

export type ApiEndpointInvoke = ApiEndpointBasePath | `${ApiEndpointBasePath}/${string}`;
